import { getClientCookieOptions } from '@/utils/auth/cookieSecurity';
import { getUTCEpochTime } from '@/utils/datetime';
import { deleteCookie, setCookie } from 'cookies-next';

export const SESSION_LIMIT_COOKIE_NAME = 'sessionLimit';

/** Match Amplify Cognito cookieStorage `expires: 365` so the wall-clock survives browser restarts. */
export const SESSION_LIMIT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function startSessionTimer(): void {
  setCookie(SESSION_LIMIT_COOKIE_NAME, getUTCEpochTime(), {
    ...getClientCookieOptions(),
    maxAge: SESSION_LIMIT_COOKIE_MAX_AGE_SECONDS,
  });
}

export function removeSessionTimer(): void {
  deleteCookie(SESSION_LIMIT_COOKIE_NAME, getClientCookieOptions());
}
